import { toast } from 'bulma-toast';

const saveSurv = document.getElementById("save_surv");

// Erzeugen einer ID für die Nutzende Person
const array = new Uint32Array(1);
//console.log('Unique ID: ', Date.now());
console.log("Unique ID:", self.crypto.getRandomValues(array)[0]);
export const unID = self.crypto.getRandomValues(array)[0];

//Alternative, wenn Anpassungen in der Datenbank vorgenommen würden
//export const unID = uuidv4();

// Speichern und schicken an eine Datenbank 
saveSurv.addEventListener("click", (e) => {
    e.preventDefault();

    const url = 'http://localhost:8082/create';
    const q1 = document.getElementById("q1").value;
    const q2 = document.getElementById("q2").value;
    const q3 = document.getElementById("q3").value;
    const q4 = document.querySelector('input[name=work]:checked').value;
    const q5 = document.getElementById('q5').value;
    const q6 = document.getElementById('q6').value;
    const q7 = document.querySelector('input[name=child]:checked').value;
    const q8 = document.getElementById('fromInput').value;
    const q9 = (document.getElementById('toInput').value) - q8;
    const q10 = 100 - q9 - q8;
    const q11 = document.getElementById('q11').value;
    const q12 = document.getElementById('q12').value;
    const q14 = document.getElementById('q14').value;

    // Formatierung
    let data = {
        "id": unID,
        "age": q1,
        "municipal": q2,
        "school": q3,
        "work": q4,
        "homeoffice": q5,
        "household": q6,
        "child": q7,
        "walk_bike": q8,
        "public": q9,
        "miv": q10,
        "km": q11,
        "time": q12,
        "text": q14,
    }

    // Senden
    fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json; charset=utf-8'
        },
        body: JSON.stringify(data)
    })
        .then(response => response.json())
        .then(data => {

            const saveMes = toast({
                message: data.message,
                type: 'is-success',
                position: 'bottom-right',
                pauseOnHover: true,
                duration: 8000,
                dismissible: true,
            });

        })
        .catch((error) => {

            const saveMes = toast({
                message: error,
                type: 'is-danger',
                position: 'bottom-right',
                pauseOnHover: true,
                duration: 8000,
                dismissible: true,
            });
        });
});
